<!--suppress HtmlFormInputWithoutLabel -->
<template>
    <base-input>
        <label slot="label">System Recording
            <font-awesome-icon v-if="isLoading" :icon="['fal','spinner-third']" spin></font-awesome-icon>
        </label>
        <select
                id="systemrecordingselect"
                placeholder="System Recording"
                v-model="systemrecording"
                @input="updateSystemRecording"
                @change="updateSystemRecording"
                class="form-control"
                size="small"
                name="systemrecording">
            <option class="select-primary"
                    label="No System Recording"
                    :key="null"
                    :value="null">
            </option>
            <option v-for="recording in systemrecordings"
                    class="select-primary"
                    :label="recording.name"
                    :key="recording.id"
                    :value="recording.id">
            </option>
        </select>
    </base-input>
</template>

<script>
    import {mapFields} from "vuex-map-fields";

    export default {
        name: "SystemRecordingSelector",
        props: ['value'],

        computed: {
            ...mapFields(`systemrecording`, ['systemrecordings']),
            isLoading() {
                return this.$store.getters['systemrecording/isLoading'];
            }
        },
        data() {
            return {
                systemrecording: this.value,
            };
        },
        methods: {
            updateSystemRecording() {
                this.$emit('input', this.systemrecording);
                this.$emit('change', this.systemrecording);
            }
        },
        mounted() {
            if (this.$store.getters['systemrecording/needUpdate']) {
                this.$store.dispatch('systemrecording/loadSystemRecording');
            }
        },
        watch: {
            value: function (newVal, oldVal) { // watch it
                this.systemrecording = newVal;
            }
        }
    }
</script>

<style scoped>

</style>